import { useTranslation } from "@outschool/localization";

import handAndHeartImage from "../../../../images/tutoring/hand-and-heart.png";
import lightbulbImage from "../../../../images/tutoring/lightbulb.png";
import piggieImage from "../../../../images/tutoring/piggie.png";

export const useTopValues = () => {
  const { t } = useTranslation(
    "client\\components\\tutoring\\hooks\\useTopValues"
  );

  return [
    {
      image: lightbulbImage,
      alt: t("No contracts or sales calls"),
      imageTitle: t("No contracts or sales calls"),
      description: t("Headache-free booking so your kid gets support, fast.")
    },
    {
      image: handAndHeartImage,
      alt: t("Top-rated, caring tutors"),
      imageTitle: t("Top-rated, caring tutors"),
      description: t("Thousands of experts who bring out the best in your kid.")
    },
    {
      image: piggieImage,
      alt: t("Your budget, your schedule"),
      imageTitle: t("Your budget, your schedule"),
      description: t("Tutoring on your terms, tailored to your family’s needs.")
    }
  ];
};
